import History from '@/pages/History'
import Home from '@/pages/Home'
import Notifications from '@/pages/Notifications'
import QrCode from '@/pages/QrCode'
import QrScan from '@/pages/QrScan'
import SignupComplete from '@/pages/SignupComplete'
import Store from '@/pages/Store'
import Transfer from '@/pages/Transfer'
import { getCurrentUser } from '@/services/api'
import { useWallet } from '@components/providers/WalletProvider'
import { useQuery } from '@tanstack/react-query'
import { HashRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { PreLogin } from '../pages/PreLogin'

function LoadingScreen() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#F5F5F5] text-zinc-500">
      <span className="sr-only">Loading...</span>
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-current border-t-transparent" />
    </div>
  )
}

function ActiveUserGuard() {
  const location = useLocation()
  const { isReady, isAuthenticated } = useWallet()
  const shouldFetchUser = isReady && isAuthenticated

  const { data, isLoading, isError } = useQuery({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    enabled: shouldFetchUser,
    staleTime: 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  })

  if (!isReady) {
    return <LoadingScreen />
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ returnTo: location.pathname }} replace />
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  if (isError || !data?.user.isActive) {
    return <Navigate to="/signup-complete" state={{ from: location.pathname }} replace />
  }

  return <Outlet />
}

export function Router() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<PreLogin />} />
        <Route path="/signup-complete" element={<SignupComplete />} />
        <Route element={<ActiveUserGuard />}>
          <Route path="/home" element={<Home />} />
          <Route path="/store" element={<Store />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/history" element={<History />} />
          <Route path="/qr" element={<QrCode />} />
          <Route path="/qr/scan" element={<QrScan />} />
          <Route path="/transfer" element={<Transfer />} />
        </Route>
      </Routes>
    </HashRouter>
  )
}
